import React from "react"
import classes from "./NoteButton.module.css"

type Props = {
    note: number
    onMouseEnter?: () => void
}

const NoteButton: React.FC<Props> = (props) => {
    const note: JSX.Element[] = []

    for (let i = 0; i < 11; i++) {
        let noteBody =
            props.note === i ? (
                <span className={classes.NoteBody} />
            ) : i === 0 && props.note === -1 ? (
                <span className={classes.GClef} />
            ) : null
        if (i % 2 === 0) {
            note.push(
                <div key={i} className={classes.StaffSpace}>
                    {noteBody}
                </div>
            )
        } else {
            note.push(
                <div key={i} className={classes.StaffLine}>
                    {noteBody}
                </div>
            )
        }
    }

    return (
        <div className={classes.NoteButton}>
            <div className={classes.Staff} onMouseEnter={props.onMouseEnter}>
                {note}
            </div>
        </div>
    )
}

export default NoteButton
